import { createRoutine } from 'app/common/utils/new-routines';
import type { ProjectSchemaCompat } from 'app/compat/types';
import { createAction } from 'typesafe-actions';

// ==================== Routine Types ====================

// Get Schema Version types
export type GetSchemaVersionRequest = {
  version: number;
};

export type GetSchemaVersionResponse = {
  status: 'Schema found' | 'Schema not found';
  schema: ProjectSchemaCompat;
};

// Get Schema History types
export type Version = {
  version: number;
  updated: string;
  shapeCount: number;
  queryCount: number;
  mutationCount: number;
  workflowCount?: number;
  defaultLocale?: string;
  locales?: string[];
};

export type SchemaHistoryRequest = {
  from?: number;
  size?: number;
};

export type SchemaHistoryResponse = {
  versionList: {
    total: number;
    items: Version[];
  };
};

// Restore Schema types
export type RestoreSchemaRequest = {
  version: number;
};

export type RestoreSchemaResponse = {
  version: number;
};

// ==================== Routines ====================

export const getSchemaVersionRoutine = createRoutine('schema/GET_SCHEMA_VERSION')<
  undefined,
  GetSchemaVersionRequest,
  undefined,
  GetSchemaVersionResponse,
  string,
  undefined
>();

export const getSchemaHistoryRoutine = createRoutine('schema/GET_SCHEMA_HISTORY')<
  undefined,
  SchemaHistoryRequest,
  undefined,
  SchemaHistoryResponse,
  string,
  undefined
>();

export const restoreSchemaRoutine = createRoutine('schema/RESTORE_SCHEMA')<
  undefined,
  RestoreSchemaRequest,
  undefined,
  RestoreSchemaResponse,
  string,
  undefined
>();

// ==================== Actions ====================

export const downloadSchema = createAction('schema/DOWNLOAD')<number>();
